import {
  getResultsMessage,
  searchIsEnabled,
} from "../../constants/command-palette.constants";

type Props = {
  count: number;
  total: number;
  query: string;
  isLoading: boolean;
};

export const CommandPaletteFooter = ({
  count,
  total,
  query,
  isLoading,
}: Props) => {
  const disabled = !searchIsEnabled(query) || isLoading;
  const message = getResultsMessage({
    count,
    total,
    disabled,
  });

  return (
    <div
      className="plh-flex plh-items-center plh-border-t plh-border-t-grey-6 plh-bg-white plh-p-4"
      data-testid="command-palette-footer"
    >
      <div className="plh-flex plh-flex-1 plh-items-center plh-gap-2 plh-font-roboto plh-text-footnote">
        <p
          data-testid="command-palette-footer-message"
          className="plh-font-roboto plh-text-grey-2"
        >
          {message}
        </p>{" "}
        {!disabled && (
          <a
            className="plh-text-brand-blue-4"
            href={`/search?q=${query}`}
            data-testid="command-palette-footer-cta"
          >
            Advanced search
          </a>
        )}
      </div>
      <ul
        className="plh-hidden plh-items-center plh-gap-3 md:plh-flex"
        data-testid="keyboard-shortcuts"
      >
        <KeyboardItem keys="↑↓" action="Navigate" />
        <KeyboardItem keys="⏎" action="Open" />
        <KeyboardItem keys="Esc" action="Exit" />
      </ul>
    </div>
  );
};

/**
 * Keyboard Item
 */
const KeyboardItem = ({ keys, action }: { keys: string; action: string }) => (
  <li
    className="plh-flex plh-items-center plh-gap-1 plh-font-roboto plh-text-footnote plh-text-grey-5"
    data-testid={`keyboard-item-${action}`}
  >
    <div className="plh-h-[19px] plh-rounded-[5px] plh-bg-grey-7 plh-px-1 plh-py-[1px]">
      <kbd
        aria-label={`Keyboard key: ${keys}`}
        data-testid="keyboard-item-keys"
      >
        {keys}
      </kbd>
    </div>
    <p data-testid="keyboard-item-action" aria-label={`to ${action}`}>
      {action}
    </p>
  </li>
);
